import { SvgIcon } from "@mui/material";
import React from "react";

const StarOutlineEmpty = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      id="Vector"
      d="M5.48545 5.22651L7.39942 1.37119C7.64508 0.876269 8.35496 0.876269 8.60062 1.37119L10.5146 5.22651L14.7948 5.84855C15.344 5.92836 15.5628 6.59956 15.1653 6.98456L12.0686 9.98344L12.7994 14.22C12.8933 14.7641 12.3189 15.1789 11.8275 14.922L8.00002 12.9206L4.17247 14.922C3.68109 15.1789 3.10671 14.7641 3.20056 14.22L3.93136 9.98344L0.834777 6.98456C0.437192 6.59956 0.656071 5.92836 1.20524 5.84855L5.48545 5.22651Z"
      stroke="#0F0B36"
      fill="inherit"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1 1"
    />
  </SvgIcon>
);
export default StarOutlineEmpty;
